export default __webpack_public_path__ + "static/media/MH-HAT-SIDE.c3645807.png";